<template>
  <!-- 卡片 -->
  <div class="problem">
    <p class="name">{{name}}</p>
    <div class="authentication">
      <p class="title">{{params.name}}</p>
      <div v-html="params.value"></div>
    </div>
  </div>
  
</template>
<script>
// 导入组件
export default {
  data() {
    return {
    }
  },
  props:{
    name: {
      type: String,
      default: '',
    },
    params: {
      type: Object,
      default: () => ({}),
    }
  }
}
</script>
<style scoped>
  .problem .name{
    font-family: SourceHanSansCN;
    font-weight: 600;
    font-size: 16px;
    color: #333333;
    line-height: 16px;
    border-left: 3px solid #f15903;
    padding-left: 10px;
    margin-bottom: 20px;
  }
  @media (min-width: 1366px) {
    .main-con { 
        width: 1000px;
      }
    }
  @media (min-width: 1600px) {
    .main-con {
      width: 1300px;
    }
  }

  .main-con {
    margin: auto;
    padding-bottom: 40px;
  }
  .index-con {
    height: 100%;
    box-sizing: border-box;
    margin: auto;
  }
  
  .aside {
    width: 64px !important;
    height: 100%;
    background-color: #334157;
    margin: 0px;
  }
  .asideshow {
    width: 240px !important;
    height: 100%;
    margin: 0px;
  }
  .index-main{
    margin-left: 20px !important;
  }
  .index-header,
  .index-main,
  .index-footer {
    padding: 0px;
    height: auto;
    margin: 0; 
  }

  .authentication .title{
    font-family: SourceHanSansCN;
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    border-bottom: 1px solid #E5E5E5;
    padding-bottom: 12px;
  }
  .authentication div{
    margin-top: 20px;
    font-family: SourceHanSansCN;
    font-weight: 500;
    font-size: 12px;
    color: #666666;
  }
  
</style>



// WEBPACK FOOTER //
// src/views/support/details.vue